export default __webpack_public_path__ + "static/media/digidzn-vid.4ac3484e.510ceade.gif";